import { bool } from 'prop-types'

import { withI18n } from 'shared/utils/withI18n'
import Flag from 'views/components/atoms/Flag'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import { PRESCRIPTION_INFO_MODAL_HOME_ONE_ID } from 'views/consts'
import { i18nType } from 'views/utils/propTypes'

const ProductLabelPrescription = ({ prescription, i18n }) =>
  prescription ? (
    <li
      data-a11y-dialog-show={PRESCRIPTION_INFO_MODAL_HOME_ONE_ID}
      className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer o-ProductLabels__prescription-label"
    >
      <Flag
        label={i18n._('prescription.labels.prescriptionRequired')}
        prescription
      >
        <span className="u-padding-x-small--left l-flex o-ProductLabels__icon-wrapper">
          <IconCircleInfo size="x-small" />
        </span>
      </Flag>
    </li>
  ) : null

ProductLabelPrescription.propTypes = {
  i18n: i18nType.isRequired,
  prescription: bool,
}

ProductLabelPrescription.defaultProps = {
  prescription: false,
}

export default withI18n()(ProductLabelPrescription)
